import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { CATEGORIES } from '../lib/constants';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';

const { FiArrowLeft, FiEdit2, FiCalendar, FiMapPin, FiLayers, FiFileText, FiPackage, FiSettings, FiDownload, FiExternalLink, FiZap, FiActivity, FiTool, FiMaximize, FiImage, FiVolume2, FiSun, FiInfo, FiBox } = FiIcons;

const SPEC_DISPLAY_CONFIG = {
  sets: [
    { key: 'year', label: 'Baujahr', icon: FiCalendar },
    { key: 'sound', label: 'Sound', icon: FiVolume2 },
    { key: 'light', label: 'Beleuchtung', icon: FiSun },
    { key: 'transformer', label: 'Transformator', icon: FiZap }
  ],
  loks: [
    { key: 'lok_type', label: 'Lok-Typ', icon: FiActivity },
    { key: 'year', label: 'Baujahr', icon: FiCalendar },
    { key: 'sound', label: 'Sound', icon: FiVolume2 },
    { key: 'light', label: 'Beleuchtung', icon: FiSun },
    { key: 'coupling', label: 'Kupplung', icon: FiLayers },
    { key: 'drive', label: 'Antrieb', icon: FiTool }
  ],
  waggons: [
    { key: 'type', label: 'Waggon-Typ', icon: FiPackage },
    { key: 'epoch', label: 'Epoche', icon: FiCalendar },
    { key: 'coupling', label: 'Kupplung', icon: FiLayers },
    { key: 'interior_light', label: 'Innenbeleuchtung', icon: FiSun },
    { key: 'year', label: 'Baujahr', icon: FiCalendar },
    { key: 'sound', label: 'Sound', icon: FiVolume2 }
  ],
  gleise: [
    { key: 'track_type', label: 'Gleis-Typ', icon: FiSettings },
    { key: 'length', label: 'Länge (mm)', icon: FiMaximize },
    { key: 'radius', label: 'Radius', icon: FiActivity }
  ],
  weichen: [
    { key: 'turnout_type', label: 'Weichen-Typ', icon: FiSettings },
    { key: 'length', label: 'Länge (mm)', icon: FiMaximize },
    { key: 'radius', label: 'Radius', icon: FiActivity },
    { key: 'drive', label: 'Antrieb', icon: FiZap },
    { key: 'digital_controllable', label: 'Digital steuerbar', icon: FiSettings },
    { key: 'decoder_integrated', label: 'Decoder integriert', icon: FiBox },
    { key: 'illuminated', label: 'Beleuchtet', icon: FiSun }
  ],
  signale: [
    { key: 'signal_type', label: 'Signal-Bauart', icon: FiActivity },
    { key: 'signal_function', label: 'Signal-Funktion', icon: FiSettings },
    { key: 'signal_aspects', label: 'Signalbilder', icon: FiSun },
    { key: 'prototype', label: 'Vorbild', icon: FiInfo },
    { key: 'length', label: 'Länge (mm)', icon: FiMaximize },
    { key: 'width', label: 'Breite (mm)', icon: FiMaximize },
    { key: 'height', label: 'Höhe (mm)', icon: FiMaximize },
    { key: 'with_base', label: 'Sockel', icon: FiLayers },
    { key: 'digital_controllable', label: 'Digital steuerbar', icon: FiZap },
    { key: 'decoder_integrated', label: 'Decoder integriert', icon: FiBox },
    { key: 'decoder_type', label: 'Decoderart', icon: FiSettings },
    { key: 'usage_context', label: 'Einsatz', icon: FiMapPin }
  ],
  zubehoer: [
    { key: 'acc_type', label: 'Zubehör-Art', icon: FiPackage },
    { key: 'bridge_part', label: 'Brückenteil', icon: FiSettings },
    { key: 'transformer', label: 'Transformator', icon: FiZap },
    { key: 'level_crossing', label: 'Bahnübergang', icon: FiActivity },
    { key: 'prototype', label: 'Vorbild', icon: FiInfo },
    { key: 'length', label: 'Länge (mm)', icon: FiMaximize },
    { key: 'width', label: 'Breite (mm)', icon: FiMaximize },
    { key: 'height', label: 'Höhe (mm)', icon: FiMaximize },
    { key: 'diameter', label: 'Durchmesser (mm)', icon: FiMaximize },
    { key: 'with_base', label: 'Sockel', icon: FiLayers },
    { key: 'digital_controllable', label: 'Digital steuerbar', icon: FiZap },
    { key: 'decoder_integrated', label: 'Decoder integriert', icon: FiBox },
    { key: 'decoder_type', label: 'Decoderart', icon: FiSettings },
    { key: 'usage_context', label: 'Einsatz', icon: FiMapPin }
  ],
  zubehoer_ersatz: [
    { key: 'category_ersatz', label: 'Kategorie', icon: FiPackage },
    { key: 'decoder_types_detail', label: 'Decoder Typ', icon: FiSettings },
    { key: 'protocols_detail', label: 'Protokolle', icon: FiZap },
    { key: 'interfaces_detail', label: 'Schnittstelle', icon: FiLayers },
    { key: 'protocol_central', label: 'Zentralen-Protokoll', icon: FiActivity },
    { key: 'booster_type', label: 'Booster-Typ', icon: FiZap },
    { key: 'status_led', label: 'LED Status', icon: FiSun },
    { key: 'kit_manufacturer', label: 'Bausatz-Hersteller', icon: FiTool },
    { key: 'landscape_manufacturer', label: 'Landschaft-Marke', icon: FiMapPin },
    { key: 'figure_manufacturer', label: 'Figuren-Marke', icon: FiPackage },
    { key: 'tool_manufacturer', label: 'Werkzeug-Hersteller', icon: FiTool },
    { key: 'spare_part_type', label: 'Ersatzteil-Art', icon: FiSettings },
    { key: 'desc_product', label: 'Produktbeschreibung', icon: FiFileText }
  ]
};

const DetailItem = ({ label, value, icon: Icon, className = "" }) => (
  <div className={`flex items-start gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 ${className}`}>
    <div className="mt-0.5 text-yellow-500">
      <SafeIcon icon={Icon} size={14} />
    </div>
    <div>
      <p style={{ fontSize: '10px', textAlign: 'left', fontWeight: '600' }} className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{label}</p>
      <p className="text-sm font-bold text-slate-800 dark:text-white">{value || '-'}</p>
    </div>
  </div>
);

const ObjectDetails = () => {
  const { category, id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const config = CATEGORIES[category] || { label: category, color: 'bg-slate-500' };

  useEffect(() => {
    const fetchItem = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('inventory')
          .select('*')
          .eq('id', id)
          .single();

        if (error) throw error;
        if (data) {
          setItem({ ...data, pdfs: data.pdfs || [], images: data.images || [], specs: data.specs || {} });
        }
      } catch (err) {
        console.error("Error fetching item:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchItem();
  }, [id]);

  if (loading) return (
    <div className="flex flex-col items-center justify-center p-20 text-slate-400">
      <SafeIcon icon={FiIcons.FiLoader} className="text-4xl animate-spin mb-4 text-yellow-500" />
      <p className="font-bold uppercase text-xs tracking-widest">Objekt-Details werden geladen...</p>
    </div>
  );

  if (!item) return (
    <div className="text-center p-20">
      <p className="text-slate-500 font-bold mb-4">Objekt wurde nicht gefunden.</p>
      <button onClick={() => navigate(-1)} className="text-yellow-600 font-black uppercase text-xs">Zurück zur Übersicht</button>
    </div>
  );

  const formatCurrency = (val) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(val || 0);
  const categorySpecs = SPEC_DISPLAY_CONFIG[category] || [];
  const activeSpecs = categorySpecs.filter(spec => item.specs?.[spec.key] || item[spec.key]);
  const hasSpecs = activeSpecs.length > 0;

  return (
    <div className="max-w-6xl mx-auto pb-20 px-4">
      <div className="flex items-center justify-between mb-8">
        <button onClick={() => navigate(-1)} className="flex items-center text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 font-bold transition-colors">
          <SafeIcon icon={FiArrowLeft} className="mr-2" /> Zurück
        </button>
        <button onClick={() => navigate(`/inventory/${category}/${id}`)} className="flex items-center gap-2 bg-slate-900 dark:bg-yellow-500 text-white dark:text-slate-950 px-6 py-2.5 rounded-xl font-black shadow-lg hover:scale-105 transition-all active:scale-95" >
          <SafeIcon icon={FiEdit2} /> BEARBEITEN
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4 space-y-6">
          <div className="bg-white dark:bg-slate-900 p-6 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800">
            <h4 className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-4 flex items-center gap-2">
              <SafeIcon icon={FiInfo} /> Stammdaten Info
            </h4>
            <div className="space-y-4">
              <div className="flex justify-between items-center text-xs">
                <span className="text-slate-500 uppercase font-black tracking-tighter text-[9px]">Inventar-ID</span>
                <span className="font-mono bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded text-slate-700 dark:text-slate-300 font-bold">{item.inventory_id}</span>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-slate-500 uppercase font-black tracking-tighter text-[9px]">Kategorie</span>
                <span className={`px-2 py-0.5 rounded text-[10px] font-black uppercase text-white ${config?.color || 'bg-slate-500'}`}>{config?.label}</span>
              </div>
              {item.date_buy && (
                <div className="flex justify-between items-center text-xs">
                  <span className="text-slate-500 uppercase font-black tracking-tighter text-[9px]">Kaufdatum</span>
                  <span className="font-bold text-slate-700 dark:text-slate-300">{new Date(item.date_buy).toLocaleDateString('de-DE')}</span>
                </div>
              )}
            </div>
          </div>

          <div className="bg-white dark:bg-slate-900 p-6 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800">
            <h4 className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-4 flex items-center gap-2">
              <SafeIcon icon={FiFileText} /> Dokumente ({item.pdfs?.length || 0})
            </h4>
            {item.pdfs?.length > 0 ? (
              <div className="space-y-3">
                {item.pdfs.map((pdf, idx) => (
                  <div key={idx} className="flex flex-col gap-2 p-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700">
                    <div className="flex items-center gap-3 overflow-hidden">
                      <SafeIcon icon={FiFileText} className="text-red-500 shrink-0" />
                      <span className="text-xs font-bold text-slate-700 dark:text-slate-300 truncate font-mono">DOC_{idx + 1}</span>
                    </div>
                    <div className="flex gap-2">
                      <a href={pdf} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 py-1.5 bg-white dark:bg-slate-700 text-[10px] font-black uppercase text-slate-600 dark:text-slate-200 rounded-lg border dark:border-slate-600 hover:bg-slate-100 transition-colors">
                        <SafeIcon icon={FiExternalLink} size={12} /> Öffnen
                      </a>
                      <a href={pdf} download={`MoBa_${item.inventory_id}_Doc_${idx + 1}.pdf`} className="flex-1 flex items-center justify-center gap-2 py-1.5 bg-yellow-500 text-[10px] font-black uppercase text-slate-900 rounded-lg hover:bg-yellow-600 transition-colors">
                        <SafeIcon icon={FiDownload} size={12} /> Laden
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-[10px] text-slate-400 italic">Keine PDF-Dokumente hinterlegt.</p>
            )}
          </div>
        </div>

        <div className="lg:col-span-8 space-y-8">
          <div className="bg-white dark:bg-slate-900 p-8 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800">
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-3">
                <span style={{ fontSize: '20px', color: 'rgb(236,9,9)' }} className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                  {item.manufacturer}
                </span>
              </div>
              <h1 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white leading-tight mb-2">
                {item.name || item.article_number || 'Unbekanntes Objekt'}
              </h1>
              <p className="text-xl text-slate-500 dark:text-slate-400 font-medium">
                Art-Nr: <span className="font-mono text-yellow-600 dark:text-yellow-500">{item.article_number || 'N/A'}</span>
              </p>
              {item.track_system && (
                <div className="mt-2 text-xs font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
                  <SafeIcon icon={FiMaximize} size={12} /> {item.track_system}
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
              <DetailItem label="System" value={item.system} icon={FiZap} />
              <DetailItem label="Digital-Typ" value={item.digital_type} icon={FiSettings} />
              <DetailItem label="Zustand" value={item.condition} icon={FiPackage} />
              <DetailItem label="Standort" value={item.location} icon={FiMapPin} />
            </div>

            {hasSpecs && (
              <div className="mb-8 p-6 bg-yellow-50/30 dark:bg-yellow-500/5 rounded-2xl border border-yellow-100/50 dark:border-yellow-500/10">
                <h4 className="text-[10px] font-black text-yellow-600 dark:text-yellow-500 uppercase tracking-widest mb-4 flex items-center gap-2">
                  <SafeIcon icon={FiInfo} /> {config?.label} Spezifikationen
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {activeSpecs.map(spec => (
                    <DetailItem key={spec.key} label={spec.label} value={item.specs?.[spec.key] || item[spec.key]} icon={spec.icon} className="bg-white dark:bg-slate-900 border-yellow-100 dark:border-yellow-500/20" />
                  ))}
                </div>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-slate-900 dark:bg-slate-950 p-6 rounded-2xl text-white">
                <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1">Finanzen</p>
                <div className="space-y-2">
                  <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-400">Einkaufspreis:</span>
                    <span className="font-bold">{formatCurrency(item.price_buy)}</span>
                  </div>
                  <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-400">Katalogwert:</span>
                    <span className="font-bold">{formatCurrency(item.price_catalog)}</span>
                  </div>
                  <div className="pt-2 mt-2 border-t border-slate-800 flex justify-between items-end">
                    <span className="text-[10px] font-black text-yellow-500 uppercase">Wert ({item.count}x)</span>
                    <span className="text-2xl font-black text-yellow-400">{formatCurrency(item.total_value)}</span>
                  </div>
                </div>
              </div>
              <div className="bg-slate-50 dark:bg-slate-800/50 p-6 rounded-2xl border border-slate-100 dark:border-slate-700 flex flex-col justify-between">
                <div>
                  <p className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-1">Notizen</p>
                  {item.note ? (
                    <p className="text-xs text-slate-600 dark:text-slate-400 italic leading-relaxed">"{item.note}"</p>
                  ) : (
                    <p className="text-xs text-slate-400 italic">Keine Notizen vorhanden.</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-xs font-black text-slate-800 dark:text-white uppercase tracking-widest flex items-center gap-3">
              <SafeIcon icon={FiImage} className="text-yellow-500" /> Bilder & Dokumentation
              <div className="h-px flex-1 bg-slate-200 dark:bg-slate-800"></div>
            </h3>
            {item.images && item.images.length > 0 ? (
              <div className="flex flex-col gap-8">
                {item.images.map((img, idx) => (
                  <div key={idx} className="bg-white dark:bg-slate-900 p-2 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden group">
                    <div className="relative aspect-auto min-h-[200px] flex items-center justify-center bg-slate-50 dark:bg-slate-950 rounded-2xl overflow-hidden">
                      <img src={img} className="max-w-full h-auto max-h-[800px] object-contain transition-transform duration-700 group-hover:scale-[1.02]" alt={`${item.name} - Bild ${idx + 1}`} />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-slate-100 dark:bg-slate-900/50 p-20 rounded-3xl border border-dashed border-slate-300 dark:border-slate-800 flex flex-col items-center justify-center text-slate-400">
                <SafeIcon icon={FiImage} className="text-5xl mb-4 opacity-20" />
                <p className="text-xs font-bold uppercase tracking-widest">Keine Fotos hinterlegt</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObjectDetails;